<template>
  <div :class="['session-m ', { 'session-m-active': activeSession && this.newSession.id }]">
    <div>
      <div :class="['table-container ', { 'duo': hasPartners(selectedMember) }]"
        :ref="'container_' + selectedMember.id">
        <table :ref="'rightContainer_' + selectedMember.id">
          <thead>
            <tr>
              <th class="session-remarks-sec">
                <div v-if="newSession.id">
                  <span class="orange session-remark-title">{{
                    '! - ' + $t('session') }}</span><span> | {{ newSession.number }}</span>
                  <div>
                    <textarea class="unstyled-textarea"
                      @input="editSessionRemark($event)">{{ newSession.remark }}</textarea>
                  </div>
                </div>
              </th>
              <th class="new-session" v-if="newSession.id" :id="'scrollContent_' + selectedMember.id"
                @click="newSession.exercises.length == 0 ? setAbsent(true) : ''">
                <div class="th-cell">
                  <div :class="{ 'pink': newSession.absent }">{{ newSession.trainer.initials + ' - ' }}<span
                      :class="{ 'orange': newSession.remark.length > 0 }">{{
                        newSession.number
                      }}</span></div>
                  <div>{{ getWeekYear(newSession.date) }}</div>
                  <div class="day-month">
                    <span>{{ getMonth(newSession.date) }}</span>
                    <span>{{ getDay(newSession.date) }}</span>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="absent-blocker-container" :id="'tbody_' + selectedMember.id">
            <!-- Add rows and cells for the table body -->
            <div v-if="newSession.absent" class="absent-blocker">
              <!-- :style="{ height: hasPartners(selectedMember) ? '335px' : '50%' }" -->
              <div>{{ $t('absent') }}</div>
            </div>
            <tr v-for="machine, index in fit20.studioMachines" :key="machine.id">
              <td>
                <div :aria-disabled="newSession.absent"
                  :class="['machine-box', 'machine-' + machine.id, 'machine-' + machine.id + '-' + selectedMember.id, { 'selected-machine': activeSession && machine.id == selectedMachine.id }, { 'unselected': oldMachineUnselected == machine.id + '-' + selectedMember.id }]"
                  @click="activeSession && newSession.id && !exerciseStarted ? selectMachine(machine) : !exerciseStarted ? togglePopup(true, machine) : ''">
                  <div class="flex machine-box-img-settings-sec">
                    <div class="machine-box-img-settings" v-for="machineS in machineSetting[machine.id]"><img
                        v-if="machineS, machineS.image"
                        :src="fit20.storageBaseUrl + '/machine-setting/' + machineS.image + '.svg'" />
                      <span v-if="machineS && machineS.value">{{
                        machineS.value }}</span>
                    </div>
                  </div>
                  <div class="machine-box-img"><img :src="fit20.storageBaseUrl + '/machine/' + machine.name + '.svg'" />
                    <img class="execute" v-if="executeMachine && executeMachine[machine.id] == 1"
                      :src="fit20.storageBaseUrl + '/machine-setting/execute1.svg'" />
                    <img class="execute" v-if="executeMachine && executeMachine[machine.id] == 2"
                      :src="fit20.storageBaseUrl + '/machine-setting/execute2.svg'" />
                    <img class="machine-remark-ico"
                      v-if="machinesRemarks && machinesRemarks[machine.id] && machinesRemarks[machine.id].length > 0"
                      :src="fit20.storageBaseUrl + '/machine-setting/machine-remark.svg'" />
                  </div>
                </div>
              </td>
              <td id="" class="exercise-info exercise-new-session" v-if="newSession.id">
                <div class="exercise-info-cell">
                  <div v-for="exercise in newSession.exercises">
                    <div :class="['flex', { 'orange': exercise.remark.length > 0 }]"
                      v-if="exercise && machine.id == exercise.machineId">
                      <span :class="{ 'exercise-order': !exercise.remark.length > 0 }">{{ exercise.order }}</span>
                      <span v-if="exercise.remark.length > 0"> {{ ' - ' }}</span>
                      <span v-if="exercise.remark.length > 0" class="exe-remarks"> {{ ' ! ' }}</span>
                    </div>
                    <div v-if="exercise && machine.id == exercise.machineId" class="exercise-duration">{{
                      exercise.duration ? secondsToTime(exercise.duration) : '.. : ..' }}</div>
                    <div v-if="exercise && machine.id == exercise.machineId" class="exercise-weight">{{ exercise.weight
                    }}<img v-if="exercise.weightChange && exercise.weightChange != 'NONE'" width="11"
                        :src="fit20.storageBaseUrl + '/static/icons/' + exercise.weightChange + '.svg'">
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
    <div class="session-sec">
      <div :id="'scroll_' + selectedMember.id" :ref="'l_container_' + selectedMember.id"
        :class="['table-container ', { 'duo': hasPartners(selectedMember) }]">
        <table :ref="'leftContainer_' + selectedMember.id">
          <thead>
            <tr>
              <!-- <th class="session-remarks-sec">
                <div v-if="newSession.id">
                  <span class="orange session-remark-title">{{
                    '! - ' + $t('session') }}</span><span> | {{ newSession.number }}</span>
                  <div>
                    <textarea class="unstyled-textarea"
                      @input="editSessionRemark($event)">{{ newSession.remark }}</textarea>
                  </div>
                </div>
              </th>
              <th class="new-session" v-if="newSession.id" :id="'scrollContent_' + selectedMember.id"
                @click="newSession.exercises.length == 0 ? setAbsent(true) : ''">
                <div :class="{ 'pink': newSession.absent }">{{ newSession.trainer.initials + ' - ' }}<span
                    :class="{ 'orange': newSession.remark.length > 0 }">{{
                      newSession.number
                    }}</span></div>
                <div>{{ getWeekYear(newSession.date) }}</div>
                <div class="day-month">
                  <span>{{ getMonth(newSession.date) }}</span>
                  <span>{{ getDay(newSession.date) }}</span>
                </div>
              </th> -->
              <!-- <th class="new-session fake-session" v-if="newSession.id" :id="'scrollContent_' + selectedMember.id + 1"
                @click="newSession.exercises.length == 0 ? setAbsent(true) : ''">
                <div :class="{ 'pink': newSession.absent }">{{ newSession.trainer.initials + ' - ' }}<span
                    :class="{ 'orange': newSession.remark.length > 0 }">{{
                      newSession.number
                    }}</span></div>
                <div>{{ getWeekYear(newSession.date) }}</div>
                <div class="day-month">
                  <span>{{ getMonth(newSession.date) }}</span>
                  <span>{{ getDay(newSession.date) }}</span>
                </div>
              </th> -->
              <th v-for="session, index in displayedSessions" :key="session.id"
                @click="showEditSessionPopup(session, sessions.length - index)">
                <div class="th-cell">
                  <div :class="{ 'pink': session.absent }">{{ session.trainer.initials + ' - ' }}<span
                      :class="{ 'orange': session.remark.length > 0 }">{{
                        (sessions.length - index)
                      }}</span></div>
                  <div class="day-month">{{ getWeekYear(session.date) }}</div>
                  <div class="day-month">
                    <span>{{ getMonth(session.date) }}</span>
                    <span>{{ getDay(session.date) }}</span>
                  </div>
                </div>
              </th>
              <!-- start more session btn -->
              <th v-if="displayedSessions.length > 0 && displayedSessions.length < 7">
                <div><span></span></div>
                <div></div>
                <div class="day-month"><span></span>
                </div>
              </th>
              <!-- end more session btn -->
            </tr>
          </thead>
          <tbody class="absent-blocker-container" :id="'tbody_' + selectedMember.id">
            <!-- Add rows and cells for the table body -->
            <!-- <div v-if="newSession.absent" class="absent-blocker"> -->
            <!-- :style="{ height: hasPartners(selectedMember) ? '335px' : '50%' }" -->
            <!-- <div>{{ $t('absent') }}</div> -->
            <!-- </div> -->
            <tr v-for="machine, index in fit20.studioMachines" :key="machine.id">
              <!-- <td>
                <div :aria-disabled="newSession.absent"
                  :class="['machine-box', 'machine-' + machine.id, 'machine-' + machine.id + '-' + selectedMember.id, { 'selected-machine': activeSession && machine.id == selectedMachine.id }, { 'unselected': oldMachineUnselected == machine.id + '-' + selectedMember.id }]"
                  @click="activeSession && newSession.id && !exerciseStarted ? selectMachine(machine) : !exerciseStarted ? togglePopup(true, machine) : ''">
                  <div class="flex machine-box-img-settings-sec">
                    <div class="machine-box-img-settings" v-for="machineS in machineSetting[machine.id]"><img
                        v-if="machineS, machineS.image"
                        :src="fit20.storageBaseUrl + '/machine-setting/' + machineS.image + '.svg'" />
                      <span v-if="machineS && machineS.value">{{
                        machineS.value }}</span>
                    </div>
                  </div>
                  <div class="machine-box-img"><img :src="fit20.storageBaseUrl + '/machine/' + machine.name + '.svg'" />
                    <img class="execute" v-if="executeMachine && executeMachine[machine.id] == 1"
                      :src="fit20.storageBaseUrl + '/machine-setting/execute1.svg'" />
                    <img class="execute" v-if="executeMachine && executeMachine[machine.id] == 2"
                      :src="fit20.storageBaseUrl + '/machine-setting/execute2.svg'" />
                    <img class="machine-remark-ico"
                      v-if="machinesRemarks && machinesRemarks[machine.id] && machinesRemarks[machine.id].length > 0"
                      :src="fit20.storageBaseUrl + '/machine-setting/machine-remark.svg'" />
                  </div>
                </div>
              </td> -->
              <!-- <td id="" class="exercise-info exercise-new-session" v-if="newSession.id">
                <div v-for="exercise in newSession.exercises">
                  <div :class="['flex', { 'orange': exercise.remark.length > 0 }]"
                    v-if="exercise && machine.id == exercise.machineId">
                    <span :class="{ 'exercise-order': !exercise.remark.length > 0 }">{{ exercise.order }}</span>
                    <span v-if="exercise.remark.length > 0"> {{ ' - ' }}</span>
                    <span v-if="exercise.remark.length > 0" class="exe-remarks"> {{ ' ! ' }}</span>
                  </div>
                  <div v-if="exercise && machine.id == exercise.machineId" class="exercise-duration">{{
                    exercise.duration ? secondsToTime(exercise.duration) : '.. : ..' }}</div>
                  <div v-if="exercise && machine.id == exercise.machineId" class="exercise-weight">{{ exercise.weight
                  }}<img v-if="exercise.weightChange && exercise.weightChange != 'NONE'" width="11"
                      :src="fit20.storageBaseUrl + '/static/icons/' + exercise.weightChange + '.svg'">
                  </div>
                </div>
              </td> -->
              <td class="exercise-info" v-for="session in displayedSessions">
                <div class="exercise-info-cell">
                  <div v-for="exercise in session.exercises.filter(e => e && e.machineId === machine.id)"
                    @click="showQsPopup(exercise, session.date)">
                    <div :class="['flex', { 'orange': exercise.remark.length > 0 }]"
                      v-if="exercise && machine.id == exercise.machineId">
                      <span :class="{ 'exercise-order': !exercise.remark.length > 0 }">{{ exercise.order }}</span>
                      <span v-if="exercise.remark.length > 0"> {{ ' - ' }}</span>
                      <span v-if="exercise.remark.length > 0" class="exe-remarks"> {{ ' ! ' }}</span>
                    </div>
                    <div v-if="exercise && machine.id == exercise.machineId" class="exercise-duration">{{
                      exercise.duration ? secondsToTime(exercise.duration) : '.. : ..' }}</div>
                    <div v-if="exercise && machine.id == exercise.machineId" class="exercise-weight">{{ exercise.weight
                    }}<img v-if="exercise.weightChange && exercise.weightChange != 'NONE'" width="11"
                        :src="fit20.storageBaseUrl + '/static/icons/' + exercise.weightChange + '.svg'">
                    </div>
                  </div>
                </div>
              </td>
              <!-- start more session btn -->
              <td class="flex more-session-btn exercise-info" @click="displayAllSessions()"
                v-if="index == 2 && displayedSessions.length > 0 && displayedSessions.length == 6 && sessions.length > 6">
                <img :class="newSession.id ? 'more-session-btn-active-session' : 'more-session-btn'"
                  :src="fit20.storageBaseUrl + '/static/icons/all-session.png'" />
              </td>
              <!-- end more session btn -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- start machine setting popup -->
    <div class="popup-overlay machine-setting-popup " v-if="showEditMachineSetting">
      <div class="edit-member animated zoomIn">
        <div class='popup-title flex'>
          <span>{{ selectedMember.displayFirstName }}</span>
          <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'"
            @click="togglePopup(false, true)" />
        </div>
        <div class="machine-settings-popup-body">
          <br>
          <div class="flex">
            <div class="edit-machine-s-img-sec-popup" @click="setMachineExecute(selectedMachine.id)">
              <img width="100" :src="fit20.storageBaseUrl + '/machine/' + selectedMachine.name + '.svg'" />
              <img class="execute" v-if="executeMachine && executeMachine[selectedMachine.id] == 1"
                :src="fit20.storageBaseUrl + '/machine-setting/execute1.svg'" width="100" />
              <img class="execute" v-if="executeMachine && executeMachine[selectedMachine.id] == 2"
                :src="fit20.storageBaseUrl + '/machine-setting/execute2.svg'" width="100" />
              <img class="machine-remark-ico machine-remark-ico-popup"
                v-if="selectedMachine && machinesRemarks[selectedMachine.id].length > 0"
                :src="fit20.storageBaseUrl + '/machine-setting/machine-remark.svg'" />
            </div>
            <div class="machine-s-sec">
              <div class="vag-light">{{ selectedMachine.name }}</div>
              <div class="flex edit-machine-s-popup">
                <div class="edit-machine-icon-sec" v-for="machineS, index in machineSetting[selectedMachine.id]"
                  @click="editMachineSetting(selectedMachine.id, index)">
                  <img v-if="machineS, machineS.image"
                    :src="fit20.storageBaseUrl + '/machine-setting/' + machineS.image + '.svg'" width="40" />
                  <span v-if="machineS && machineS.value">{{ machineS.value }}</span>
                  <div v-if="isDropdownOpenIndex == index && machineS.values" class="dropdown-container">
                    <div class="dropdown-options">
                      <div v-for="value in machineS.values"
                        @click="editMachineSetting(selectedMachine.id, index, value, $event)" class="dropdown-option">
                        {{ value }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="selectedMachine" class="machine-setting-sec3">
            <div class="machine-s-remark-title"><span class="orange ">{{
              '! - ' + $t('machine') }}</span><span> | </span>
              <div>
                <textarea class="unstyled-textarea" :id="'machine_remark' + member.id"
                  v-model="machinesRemarks[selectedMachine.id]">
            </textarea>
              </div>
            </div>
          </div>
          <div class="btn-container">
            <img class="new-session-btn" width="60px" :src="fit20.storageBaseUrl + '/static/icons/save.png'"
              @click="saveMemberMachineSetting(selectedMachine.id)">
          </div>
          <br>
        </div>
      </div>
    </div>
    <!-- end machine setting popup -->

    <!-- start absent popup -->
    <div class="popup-overlay machine-setting-popup" v-if="showAbsentPopup">
      <div class="edit-member animated zoomIn">
        <div class='popup-title flex'>
          <span>{{ selectedMember.displayFirstName }}</span>
          <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="setAbsent()" />
        </div>
        <div>
          <br>
          <div class="flex absent-sec">
            <div class="sec2">{{ $t("absent") }}</div>
            <div class="sec3">
              <input :id="'absent' + selectedMember.id" type="checkbox" :checked="newSession.absent"
                class="partners-checkbox" @input="makeMemberAbsent($event)" />
            </div>
          </div>
          <!-- start absent option -->
          <div class="add-remarks-body" v-if="showAbsentOption">
            <select class="select-remarks" v-model="newSession.absentReason">
              <option value="">{{ $t('select-reason') }}</option>
              <option :value="reason" v-for="reason in fit20.absentReasons">{{ $t(reason) }}</option>
            </select>
            <span v-if="!absentError">{{ $t(newSession.absentReason) }}</span>
            <span v-if="absentError" class="absent-error">{{ $t('general-err-msg') }}</span>
            <textarea v-model="newSession.remark" class="text-area-remarks" name=""
              :placeholder="$t('session') + ' ' + $t('remarks')" rows="5"></textarea>
          </div>
          <!-- end absent option -->
          <div class="btn-container">
            <img class="new-session-btn" width="60px" :src="fit20.storageBaseUrl + '/static/icons/save.png'"
              @click="saveMemberAbsent()">
          </div>
          <br>
        </div>
      </div>
    </div>
    <!-- end absent popup -->

    <!-- start QS popup -->
    <div class="popup-overlay machine-setting-popup" v-if="selectedQs">
      <div class="edit-member animated zoomIn">
        <div class='popup-title flex'>
          <span>{{ '' }}</span>
          <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'"
            @click="showQsPopup(false, false)" />
        </div>
        <div>
          <br>
          <div class="flex qs-first-row">

            <div> {{ getDay(selectedQsDate) + ' ' + getMonth(selectedQsDate) + ' ' +
              getWeekYear(selectedQsDate).slice(0,
                4) }}</div>

            <div>{{ selectedQs.weight + 'kg' }}</div>
            <div>{{ selectedQs.duration ? secondsToTime(selectedQs.duration) : '.. : ..' }}</div>
          </div>

          <br>
          <div class="flex qs-second-row">
            <div class="edit-machine-s-img-sec qs-first-col ">
              <img width="150" :src="fit20.storageBaseUrl + '/static/icons/Quality-score.png'" />
              <div>{{ selectedQs.qs_average ? selectedQs.qs_average : '---' }}</div>
            </div>
            <div class="">
              <div class="flex qs-second-col">
                <img width="40" height="60" :src="fit20.storageBaseUrl + '/static/icons/Tempo.png'" />
                <div>{{ selectedQs.qs_average ? selectedQs.qs_tempo : '---' }}</div>
              </div>
              <div class="flex qs-second-col">
                <img width="40" height="60" :src="fit20.storageBaseUrl + '/static/icons/Rhythm.png'" />
                <div>{{ selectedQs.qs_average ? selectedQs.qs_rhythm : '---' }}</div>
              </div>
              <div class="flex qs-second-col">
                <img width="40" height="60" :src="fit20.storageBaseUrl + '/static/icons/Range.png'" />
                <div>{{ selectedQs.qs_average ? selectedQs.qs_range : '---' }}</div>
              </div>
            </div>
          </div>
          <div class="qs-popup-remarks">
            <div
              v-if="selectedMember.machinesSettings.find(machine => machine.machineId == selectedQs.machineId).remark">
              <span class="orange">{{ '! - ' + $t('machine') + ': '
              }}</span>{{selectedMember.machinesSettings.find(machine => machine.machineId ==
                  selectedQs.machineId).remark}}
            </div>
            <div v-if="selectedQs.remark.length > 0"><span class="orange">{{ '! - ' + $t('exercise') + ': ' }}</span>
              {{ selectedQs.remark }}</div>
            <div v-if="fit20.user.role == 'admin'">{{
              $t('sensor position on select machine: ') + selectedQs.sensor_position }}</div>
          </div>
          <br>
        </div>
      </div>
    </div>
    <!-- end QS popup -->



    <!-- edit session popup -->
    <div class="popup-overlay machine-setting-popup" v-if="selectedSession">
      <div class="edit-member animated zoomIn">
        <div class='popup-title flex'>
          <span>{{ '' }}</span>
          <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="showEditSessionPopup()" />
        </div>
        <div>
          <br>
          <div class="flex qs-first-row">
            <div>
              <div> {{ getDay(selectedSession.date) + ' ' + getMonth(selectedSession.date) + ' ' +
                getWeekYear(selectedSession.date).slice(0,
                  4) + ' - ' + getTime(selectedSession.date) }} </div>
            </div>

          </div>

          <br>
          <div class="flex edit-session-qs-second-row center-qs">
            <div class="flex qs-width">
              <img width="90" height="90" :src="fit20.storageBaseUrl + '/static/icons/Quality-score.png'" />
              <div>{{ selectedSession.training_age && selectedSession.training_age.overall_qs &&
                selectedSession.training_age.overall_qs.qs_average ?
                selectedSession.training_age.overall_qs.qs_average : '---' }}
              </div>
            </div>

            <div class="flex qs-width" v-if="fit20.user.role == 'admin'">
              <img width="110" height="110" :src="fit20.storageBaseUrl + '/static/icons/fit20-age.png'" />
              <div>{{ selectedSession.training_age && selectedSession.training_age.train_at_level ?
                Math.floor(selectedSession.training_age.train_at_level) : '---' }}</div>
            </div>
          </div>

          <br>
          <div class="flex edit-session-qs-3-row">
            <div class="flex qs-3-row">
              <img width="50" height="50" :src="fit20.storageBaseUrl + '/static/icons/Tempo.png'" />
              <div>{{ selectedSession.training_age && selectedSession.training_age.overall_qs
                && selectedSession.training_age.overall_qs.qs_tempo ?
                selectedSession.training_age.overall_qs.qs_tempo : '---' }}</div>
            </div>
            <div class="flex qs-3-row">
              <img width="50" height="50" :src="fit20.storageBaseUrl + '/static/icons/Rhythm.png'" />
              <div>{{ selectedSession.training_age && selectedSession.training_age.overall_qs
                && selectedSession.training_age.overall_qs.qs_rhythm ?
                selectedSession.training_age.overall_qs.qs_rhythm : '---' }}</div>
            </div>
            <div class="flex qs-3-row">
              <img width="50" height="50" :src="fit20.storageBaseUrl + '/static/icons/Range.png'" />
              <div>{{ selectedSession.training_age && selectedSession.training_age.overall_qs
                && selectedSession.training_age.overall_qs.qs_range ?
                selectedSession.training_age.overall_qs.qs_range : '---' }}</div>
            </div>
          </div>
          <br>
          <div class=" qs-first-row" v-if="selectedSession.absent">{{ $t("absent") + ": " +
            $t(selectedSession.absentReason)
          }}</div>

          <div class="flex session-remarks-in-popup-container">
            <div>{{ $t('session') + ' ' + $t('remarks') }}</div>
            <div class="session-remarks-in-popup">{{ selectedSession.remark ? selectedSession.remark : '' }}
            </div>
          </div>
          <br>
          <div class="btn-container edit-session-btn" v-if="!activeSession && !newSession.id">
            <img width="75" :src="fit20.storageBaseUrl + '/static/icons/edit.svg'" @click="startEditSession()" />
          </div>
          <br>
        </div>
      </div>
    </div>
    <!-- edit session popup -->
  </div>
</template>

<script>
export default {
  name: 'SessionM',
  props: ["fit20", "member", "selectedMember", "tabNum", "sessions", "formatDate", "showEditMachineSetting", "originalMember",
    "activeSession", "newSession", "displayedSessions", "selectedMachine", "machineSetting", "executeMachine", "editSession",
    "isDropdownOpenIndex", "isChanged", "setMachineExecute", "editMachineSetting", "saveMemberMachineSetting", "hasPartners",
    "selectMachine", "togglePopup", "editSessionRemark", "setAbsent", "showAbsentPopup", 'showAbsentOption', "makeMemberAbsent",
    "saveMemberAbsent", "absentError", "oldMachineUnselected", "displayAllSessions", "exerciseStarted", "machinesRemarks"
  ],
  data() {
    return {
      selectedQs: false,
      selectedQsDate: false,
      selectedSession: false,
      selectedSessionNum: false
    }
  },
  methods: {
    showEditSessionPopup(session, num) {
      if (session) {
        this.selectedSession = session;
        this.selectedSessionNum = num;
      } else {
        this.selectedSession = false;
        this.selectedSessionNum = false;
      }
    },
    isExerciseDone(machineId) {
      if (this.newSession && this.newSession.exercises && this.newSession.exercises.length > 0) {
        let exercise = this.newSession.exercises.find(exe => exe.machineId == machineId);
        if (exercise && exercise.order > 0) {
          return true
        } else {
          return false
        }
      }
    },
    startEditSession() {
      this.editSession(this.selectedSession, this.selectedSessionNum);
      this.selectedSession = false;
      this.selectedSessionNum = false;
    },
    showQsPopup(exe, date) {
      this.selectedQs = exe;
      this.selectedQsDate = date;
    },

    capitalizeFirstLetter(string) {
      if (string) {
        return string[0].toUpperCase() + string.slice(1);
      } else {
        return '';
      }
    },
    secondsToTime: function (seconds) {
      let minutes = Math.floor(seconds / 60);
      let remainingSeconds = seconds % 60;

      // Use template literals to format the time
      return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    },
    getWeekYear: function (dateString) {
      const date = new Date(dateString);
      const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
      // const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
      // return d.getUTCFullYear() + " - " + Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
      // const date = new Date(dateString);
      const year = date.getFullYear();

      // Jan 1 of this year
      const start = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));

      // Days passed since Jan 1
      const diff = (date - start) / 86400000;

      // Week number (rounding up)
      const week = Math.ceil((((d - start) / 86400000) + 1) / 7)

      return year + " - " + week;
    },
    getDay: function (dateString) {
      const date = new Date(dateString);
      const day = date.getDate();
      return day;
    },
    getMonth: function (dateString) {
      const date = new Date(dateString);
      const month = date.toLocaleDateString('en-US', {
        month: 'short'
      }).toUpperCase();
      return month;
    },
    getTime: function (dateString) {
      const date = new Date(dateString);
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}`;
    },
    syncHeights() {
      const left = this.$refs['leftContainer_' + this.selectedMember.id];
      const right = this.$refs['rightContainer_' + this.selectedMember.id];
      left.style.height = right.scrollHeight + 'px';
    },

  },

  mounted() {
    const left = this.$refs['container_' + this.selectedMember.id];
    const right = this.$refs['l_container_' + this.selectedMember.id];
    let syncing = false;

    left.addEventListener('scroll', () => {
      if (syncing) return;

      syncing = true;
      right.scrollTop = left.scrollTop;

      requestAnimationFrame(() => {
        syncing = false;
      });
    });

    right.addEventListener('scroll', () => {
      if (syncing) return;

      syncing = true;
      left.scrollTop = right.scrollTop;

      requestAnimationFrame(() => {
        syncing = false;
      });
    });

    this.$nextTick(() => {

      setTimeout(() => {
        $('#scroll_' + this.selectedMember.id).scrollLeft(0); // Use a positive value here
        this.syncHeights();
      }, 500); // Adjust the delay if needed

    })
  }
};
</script>

<style>
tr {
  height: 45px;
}

.machine-setting-popup {
  direction: ltr;
}

.qs-popup-remarks {
  text-align: center;
}

.edit-session-btn {
  margin-right: 35px !important;
}

.more-session-btn {
  width: 45px;
}

.more-session-btn img {
  width: 60px;
  height: 86px;
  position: absolute;
}

.more-session-btn-active-session {
  width: auto !important;
  height: 45px !important;
  position: relative !important;

}

.exe-remarks {
  font-weight: bold;
}

.exercise-weight {
  /* // position: relative; */
  color: black;
}

.exercise-weight img {
  height: auto !important;
  /* position: absolute;
  overflow: visible !important; */
}

.session-m td,
.session-m th:not(.session-remarks-sec) {
  overflow: hidden;
  overflow-y: auto;
}

.session-remarks-sec {
  height: 65px;
}

/*  some classes can be in Session component */
.table-container {
  display: block;

  overflow-x: auto;
  direction: rtl;
  height: calc(100% - 20px);
}

@media (hover: none) and (pointer: coarse) {
  .table-container {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .table-container::-webkit-scrollbar {
    display: none;
  }
}

.session-sec {
  width: calc(100% - 140px);
  /* box-sizing: border-box; */
  /* max-width: 370px; */
  /* z-index: -1; */
}

.session-m-active .session-sec {
  width: calc(100% - 193px);
}

.duo {
  height: 390px;
}

/* Table styles */
.table-container table {
  /* width: max-content; */
  overflow-y: scroll;
  border-collapse: collapse;
}

/* Table header styles */
.table-container th {
  padding: 1px 2px;
  padding-top: 20px;
  position: sticky;
  top: 0;
  z-index: 2;
  font-size: 11px;
  line-height: 14px;
  font-weight: 300;
  font-family: 'open sans', sans-serif !important;
  min-width: 58px;
}

.table-container tr {
  border-bottom: solid 2px rgba(88, 88, 88, 0.11);
  ;
}

/* Table body styles */
.table-container td {
  text-align: left;
  padding: 0px 5px;
}

/* .table-container td:first-child {
  position: sticky;
  right: 0;
  z-index: 1;
  overflow-y: hidden;
  background-color: white;
} */

.table-container td.exercise-new-session {
  /* position: sticky;
  right: 140px; */
  z-index: 2 !important;
  overflow-y: auto;
  background-color: var(--fit20-lighter-blue);
}

.table-container th {
  position: sticky;
  top: 0;
  z-index: 1;
  overflow: scroll;
  background-color: white;
}

.table-container th:first-child {
  z-index: 2;
  /* right: 0; */
  overflow: hidden;
}

.day-month {
  display: flex;
  justify-content: end;
  gap: 5px;
}

.machine-box {
  width: 130px;
  height: 43px;
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  font-family: 'open sans', sans-serif;
}

.machine-box-img-settings-sec {
  width: calc(100% / 5 * 3);
}

.machine-box-img-settings {
  width: calc(100% / 3);
  height: 18px;
  position: relative;
  padding: 2px;
}

.machine-box-img-settings img {
  width: 100%;
  height: 100%;
}

.machine-box-img-settings span {
  position: absolute;
  right: 12px;
  top: 0px;
  font-size: 11px;
}

.machine-box-img {
  width: calc(100% / 5 * 2);
  height: 36px;
  position: relative;
}

.machine-box-img img {
  width: 100%;
  height: 36px;
}

.edit-machine-s-popup {
  justify-content: space-between;
  flex-direction: row-reverse;
  padding: 10px;
  margin-top: 35px;
}

.machine-settings-popup-body .unstyled-textarea {
  width: 100%;
  font-size: 15px;
}

.machine-settings-popup-body .machine-setting-sec3 {
  height: 75px;
}

.machine-s-remark-title {
  font-size: 18px;
}

.machine-settings-popup-body {
  padding: 20px 15px;
}

.edit-machine-icon-sec {
  position: relative;
}

.edit-machine-s-popup span {
  position: absolute;
  right: 40px;
}

.execute {
  position: absolute;
  left: 0;
  top: 0;
}

.execute2 {
  position: absolute;
  right: 0;
  border: none !important;
}

.machine-remark-ico {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px !important;
  height: 10px !important;
}

.machine-remark-ico-popup {
  left: -5px;
  width: 25px !important;
  height: 25px !important;
}

.edit-machine-s-img-sec {
  position: relative;
  display: inline-block;
}

.edit-machine-s-img-sec-popup {
  width: 20%;
  padding-left: 15px;
  position: relative;
  display: inline-block;
}

.machine-s-sec {
  width: 77%;
}

.exercise-info {
  font-size: 14px;
  line-height: 14px;
  min-width: 53px;
  font-family: 'open sans', Verdana, Geneva, Tahoma, sans-serif !important;
}

.exercise-info-cell {
  max-height: 45px;
}

.th-cell {
  max-height: 43px;
}

.exercise-info div.flex {
  flex-direction: row-reverse;
}

.exercise-info div.flex span {
  padding-right: 3px;
}

.exercise-duration {
  color: var(--fit20-blue);
}

.unselected {
  pointer-events: none;
  position: relative;
}

.unselected::before {
  content: '';
  position: absolute;
  width: 128px;
  height: 39px;
  /* top: 0;
  left: 5px; */
  background-color: rgba(255, 255, 255, 0.808);
  z-index: 4;
  border: solid 2px rgb(190, 190, 190);
  border-radius: 7px;
  overflow: hidden;
}

.absent-sec {
  margin-left: 20px;
}

.exercise-order {
  color: var(--fit20-light-gray);
}

.absent-sec .sec3 {
  margin-left: 10px;
}

.absent-sec input[type="checkbox"] {
  border: solid 1px var(--fit20-lighter-gray) !important;
  border-radius: 0px !important;
  padding: 0px !important;
  width: 20px;
  height: 20px !important;
  margin-top: 0px !important;
  margin-left: 5px;
}

.absent-sec input:checked {
  border: solid 1px var(--fit20-lighter-gray) !important;
  accent-color: var(--fit20-light-gray);
}

.add-remarks-body textarea {
  padding-left: 10px;
}

.absent-blocker-container {
  position: relative;
}

.absent-blocker {
  position: fixed;
  width: 140px;
  z-index: 2;
  background-color: rgba(196, 196, 196, 0.281);
  border-radius: 10px;
  height: 345px;
}

.absent-blocker div {
  margin-top: 90%;
  text-align: center;
  font-size: 20px;
}

.absent-error {
  margin-left: 10px;
  color: rgb(255, 106, 106);
}

.total-q-score {
  justify-content: center;
}

.total-q-score-text {
  padding: 20px 0 0 30px;
  justify-content: center;
  display: flex;
  align-items: center;
  width: 100%;
}

.qs-first-row,
.qs-second-row,
.qs-second-col {
  justify-content: space-evenly;
  text-align: center;
}

.edit-session-qs-second-row {
  font-size: 25px;
}

.edit-session-qs-3-row {
  font-size: 21px;
}

.qs-3-row {
  width: 33.333%;
  flex-direction: column;
  align-content: center;
  align-items: center;
}

.qs-3-row div {
  margin-top: 10px;
}

.center-qs {
  justify-content: center;
}

.qs-width {
  width: 50%;
  justify-content: space-evenly !important;
  align-items: center;
  padding: 0 !important;
}

.session-remarks-in-popup-container {
  padding: 20px;
  color: rgb(126, 126, 126);
  justify-content: space-evenly;
}

.session-remarks-in-popup {
  padding: 10px;
  height: 80px;
  overflow-y: auto;
  border: solid 1px rgb(196, 196, 196);
  border-radius: 10px;
  width: 70%;
}

.qs-second-col img {
  padding: 10px 0;
}

.qs-second-col div {
  padding: 20px 0 0 30px;
}

.qs-first-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
